import {
  setBackdropState,
  utilOpenLiveChat,
  trapFocus,
} from "../../helpers/util";
import { Tracking } from "../../helpers/enums";
import { pageTracking } from "../../tracking/tracking";

export const futureBooking = (root) => {
  const UPCOMING_BOOKING_PREFIX = "js-upcoming-booking";

  const VIEWS = {
    CANCEL_ROOM: `${UPCOMING_BOOKING_PREFIX}-cancel-room`,
    CANCEL_BOOKING: `${UPCOMING_BOOKING_PREFIX}-cancel-everything`,
    CANCEL_MESSAGE: `${UPCOMING_BOOKING_PREFIX}-cancel-message`,
  };

  const setActiveView = (viewName: string) => {
    const viewNames = Object.values(VIEWS);

    if (!viewNames.includes(viewName)) {
      return;
    }

    // hide all inactive views
    const inactiveViews = viewNames.filter((v) => v != viewName);
    inactiveViews.forEach((v) => {
      const view = root.querySelector(`[${v}]`);

      if (view && !view.classList.contains("display--n")) {
        view.classList.add("display--n");
      }
    });

    // show chosen active view
    const nextView = root.querySelector(`[${viewName}]`);

    if (nextView) {
      nextView.classList.remove("display--n");
      setTimeout(() => {
        const button = nextView.querySelectorAll("button")[0];
        if (button) {
          button.focus();
        }
      }, 1000);
      trapFocus(nextView);
    }
  };

  /* update guest features */
  const updateNameCta = root.querySelector(
      `[${UPCOMING_BOOKING_PREFIX}-full-name-cta] button`
    ) as HTMLElement,
    updateEmailCta = root.querySelector(
      `[${UPCOMING_BOOKING_PREFIX}-email-address-cta] button`
    ) as HTMLElement;

  const updateGuestWindow = root.querySelector(
    `[${UPCOMING_BOOKING_PREFIX}-update-booker-form]`
  ) as HTMLElement;
  const updateGuestForm = root.querySelector("form") as HTMLFormElement;

  const closeUpdateGuests = root.querySelectorAll(
    `[${UPCOMING_BOOKING_PREFIX}-update-booker-close]`
  ) as NodeList;

  /* cancellation features */
  const cancelRoomCtas = root.querySelectorAll(
    `[${UPCOMING_BOOKING_PREFIX}-cancel-room-cta]`
  ) as NodeList;
  const cancelBookingCta = root.querySelector(
    `[${UPCOMING_BOOKING_PREFIX}-cancel-cta]`
  ) as HTMLButtonElement;

  const confirmCancelWindow = root.querySelector(
    `[${UPCOMING_BOOKING_PREFIX}-cancel-confirm]`
  ) as HTMLElement;
  const isCheckedIn =
    confirmCancelWindow.getAttribute(
      `${UPCOMING_BOOKING_PREFIX}-checked-in`
    ) === "true";

  const closeCancelWindowCtas = root.querySelectorAll(
    `[${UPCOMING_BOOKING_PREFIX}-cancel-confirm-close]`
  ) as NodeList;

  if (updateNameCta && updateEmailCta) {
    [updateNameCta, updateEmailCta].forEach((cta) => {
      cta.addEventListener("click", () => {
        pageTracking(Tracking.OPEN_EDIT_GUEST_DETAILS);
        setBackdropState(updateGuestWindow, true, true);
      });
    });
  }

  if (closeUpdateGuests) {
    closeUpdateGuests.forEach((cta) => {
      cta.addEventListener("click", () => {
        setBackdropState(updateGuestWindow, false);
        updateGuestForm.reset();
      });
    });
  }

  const getCancellationMessage = (cancelCta: HTMLElement) =>
    cancelCta.getAttribute(`${UPCOMING_BOOKING_PREFIX}-cancel-message-value`);

  const setCancellationMessageContent = (content: string) => {
    const element = document.querySelector(
      `${UPCOMING_BOOKING_PREFIX}-cancel-message-content`
    ) as HTMLElement;
    if (element && content) {
      element.innerText = content;
    }
  };

  if (cancelBookingCta) {
    cancelBookingCta.addEventListener("click", () => {
      if (isCheckedIn) {
        utilOpenLiveChat();
        return;
      }

      const message = getCancellationMessage(cancelBookingCta);

      if (message) {
        setActiveView(VIEWS.CANCEL_MESSAGE);
        setCancellationMessageContent(message);
      } else {
        setActiveView(VIEWS.CANCEL_BOOKING);
      }

      pageTracking(Tracking.OPEN_CANCEL_BOOKING);
      setBackdropState(confirmCancelWindow, true, true);
    });
  }

  if (cancelRoomCtas) {
    const toggleCancelRoom = (e) => {
      if (isCheckedIn) {
        utilOpenLiveChat();
        return;
      }

      const source = e.target;

      const message = getCancellationMessage(source);

      if (message) {
        setActiveView(VIEWS.CANCEL_MESSAGE);
        setCancellationMessageContent(message);
      } else {
        // set the correct leg (room) number for cancellation in form input field
        const cancelRoomView = root.querySelector(`[${VIEWS.CANCEL_ROOM}]`);
        const cancelRoomForm = cancelRoomView.querySelector(`form`);

        const legNumberField =
          cancelRoomForm.querySelector("[name='LegNumber']");
        const legNumber = source.getAttribute(
          `${UPCOMING_BOOKING_PREFIX}-cancel-room-cta`
        );
        if (legNumber && legNumberField) {
          legNumberField.value = legNumber;
        }

        const headerField = cancelRoomView.querySelector("h4");
        const headerTemplate = headerField.getAttribute(
          `${UPCOMING_BOOKING_PREFIX}-cancel-room-title`
        ) as string;
        const roomName = source.getAttribute(
          `${UPCOMING_BOOKING_PREFIX}-cancel-room-name`
        ) as string;

        if (headerField) {
          // TODO international fallback for "this room"
          const nextTitle = headerTemplate.replace(
            "{roomName}",
            roomName ?? "this room"
          );
          headerField.innerText = nextTitle;
        }

        setActiveView(VIEWS.CANCEL_ROOM);
      }

      setBackdropState(confirmCancelWindow, true);
    };

    cancelRoomCtas.forEach((cta) => {
      cta.addEventListener("click", toggleCancelRoom);
    });
  }

  if (closeCancelWindowCtas) {
    closeCancelWindowCtas.forEach((cta) => {
      cta.addEventListener("click", () => {
        setBackdropState(confirmCancelWindow, false);
      });
    });
  }

  setActiveView(VIEWS.CANCEL_BOOKING);
};
